import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Show, SignIn, SignUp } from "@clerk/react";
import { Navigate as RRNavigate } from "react-router-dom";
import ClerkAuthProvider from "./components/auth/ClerkAuthProvider";
import { CartProvider } from "./lib/cart";
import { Toaster } from "./components/ui/sonner";

import Layout from "./components/Layout";
import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import OrderReceived from "./pages/OrderReceived";
import COAs from "./pages/COAs";
import PolicyPage from "./pages/Policy";
import Account from "./pages/Account";
import Admin from "./pages/admin/Admin";
import AdminHome from "./pages/admin/AdminHome";
import AdminProducts from "./pages/admin/AdminProducts";
import AdminOrders from "./pages/admin/AdminOrders";
import AdminCOAs from "./pages/admin/AdminCOAs";
import { AdminCustomers, AdminAnnouncements, AdminRestrictions } from "./pages/admin/AdminMisc";
import AdminPayments from "./pages/admin/AdminPayments";
import Skincare from "./pages/Skincare";
import FAQ from "./pages/FAQ";
import Contact from "./pages/Contact";
import AdminMessages from "./pages/admin/AdminMessages";

export default function App() {
  return (
    <BrowserRouter>
      <ClerkAuthProvider>
        <CartProvider>
          <Routes>
            {/* Auth routes */}
            <Route path="/sign-in/*" element={
              <div className="min-h-screen bg-[#F4EBDD] flex items-center justify-center p-6">
                <SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp />
              </div>
            } />
            <Route path="/sign-up/*" element={
              <div className="min-h-screen bg-[#F4EBDD] flex items-center justify-center p-6">
                <SignUp routing="path" path="/sign-up" signInUrl="/sign-in" />
              </div>
            } />

            {/* Public layout */}
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/product/:id" element={<ProductDetail />} />
              <Route path="/skincare" element={<Skincare />} />
              <Route path="/skincare/:id" element={<ProductDetail />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/order-received" element={<OrderReceived />} />
              <Route path="/coas" element={<COAs />} />
              <Route path="/policies/:slug" element={<PolicyPage />} />
              <Route path="/about" element={<RRNavigate to="/contact" replace />} />
              <Route path="/policies/about" element={<RRNavigate to="/contact" replace />} />
              <Route path="/policies/faq" element={<RRNavigate to="/faq" replace />} />
              <Route path="/policies/contact" element={<RRNavigate to="/contact" replace />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/account" element={
                <>
                  <Show when="signed-in"><Account /></Show>
                  <Show when="signed-out"><RRNavigate to="/sign-in" replace /></Show>
                </>
              } />
            </Route>

            {/* Admin */}
            <Route path="/admin" element={
              <>
                <Show when="signed-in"><Admin /></Show>
                <Show when="signed-out"><RRNavigate to="/sign-in" replace /></Show>
              </>
            }>
              <Route index element={<AdminHome />} />
              <Route path="products" element={<AdminProducts />} />
              <Route path="orders" element={<AdminOrders />} />
              <Route path="customers" element={<AdminCustomers />} />
              <Route path="coas" element={<AdminCOAs />} />
              <Route path="announcements" element={<AdminAnnouncements />} />
              <Route path="restrictions" element={<AdminRestrictions />} />
              <Route path="payments" element={<AdminPayments />} />
              <Route path="messages" element={<AdminMessages />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="bottom-right" />
        </CartProvider>
      </ClerkAuthProvider>
    </BrowserRouter>
  );
}
